import { useFilter } from 'shared/common/OpenFiltersButton/hooks/useFilter'
import { filtersSlice } from 'shared/common/OpenFiltersButton/model/slice'
import { Icon } from 'shared/iconpack'
import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'
import { ParamKey } from 'shared/types/QueryModel'

import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import Badge from 'shared/ui/Badge'
import { Button } from 'shared/ui/Button'

import useDynamicModuleLoader from 'shared/config/redux/hooks/useDynamicModuleLoader'
import { palette } from 'shared/config/styles/palette'

import './OpenFiltersButton.css'

interface Props {
  filters: ParamKey[]
}

const OpenFiltersButton = ({ filters }: Props) => {
  const location = useLocation()
  const { deleteParam } = useAppSearchParams()
  const { deleteKeys } = useAppSearchParams()

  useDynamicModuleLoader({
    reducers: {
      filters: filtersSlice,
    },
  })

  const {
    isOpen,
    setIsOpen,
    setIsUseFilters,
    setFilters,
    isUseFilters,
    filtersCount,
    filters: readyFilters,
    clearFilters,
    setFiltersToParams,
    countFilters,
    deleteFilter,
    checkIsRelevantFilters,
  } = useFilter(filters)

  const handleClearFilter = (options?: { replace?: boolean }) => {
    deleteKeys(filters, options)
    clearFilters()
  }

  const handleClickIsUseFilters = (isUseFilter: boolean) => {
    if (!isUseFilter) {
      handleClearFilter({ replace: false })
    }
    setIsUseFilters(isUseFilter)
  }

  useEffect(() => {
    setIsOpen(false)
    const isOpenFilters = countFilters(filters).length > 0
    setIsUseFilters(isOpenFilters)
    if (readyFilters && filters) {
      Object.keys(readyFilters).forEach((filterKey) => {
        if (!filters.some((param) => param === filterKey)) {
          deleteFilter(filterKey as ParamKey)
          deleteParam(filterKey as ParamKey)
        }
      })
    }
  }, [])

  useEffect(() => {
    if (isUseFilters) {
      setFiltersToParams()
    }
  }, [isUseFilters, readyFilters])

  useEffect(() => {
    const countedFilters = countFilters(filters)
    if (!checkIsRelevantFilters(filters)) {
      setFilters(countedFilters)
    } else if (!countedFilters?.length) {
      clearFilters()
      setIsUseFilters(false)
    }
  }, [location.search])

  useEffect(() => {
    if (!location.search) {
      setIsUseFilters(false)
      handleClearFilter({ replace: true })
    }
  }, [location.pathname])

  return (
    <div className="flex gap-[12px]">
      <Button
        className={`filtersButton group flex gap-[8px] items-center h-[36px] rounded-[12px] border-transparent
                    ${isOpen ? 'bg-light_blue_1' : 'bg-light_gray_3'}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={`flex items-center gap-[4px]`}>
          <Icon
            name="filter"
            width={20}
            height={20}
            color={palette.dark_blue_1}
          />
        </div>
        {filtersCount > 0 && (
          <Badge
            value={filtersCount}
            className="filtersBadge"
          />
        )}
      </Button>
      <Button
        disabled={isOpen || isUseFilters ? false : true}
        onClick={() => handleClickIsUseFilters(!isUseFilters)}
        className={`min-w-[100px] h-[36px] py-[8px] px-[12px] rounded-[12px] border-none 
          ${isOpen || isUseFilters ? '!bg-dark_blue_1' : '!bg-light_gray_18'}`}
      >
        <span
          className={`${isOpen || isUseFilters ? 'text-white' : 'text-light_gray_10'} font-medium text-[14px] leading-[20px]`}
        >
          {isUseFilters ? 'Сбросить' : 'Применить'}
        </span>
      </Button>
    </div>
  )
}

export default OpenFiltersButton
